export function sitelocation(api: ReturnType<typeof useAxios>) {
  const getAllLocation = async (data: any) =>
    await api.$get(
      `/sitelocation?limit=${data.limit}&page=${data.page}&sort=${data.sort}&dir=${data.dir}&search=${encodeURIComponent(data.search)}&status=${data.status}`,
    );
  const createLocation = async (data: any) => await api.$post(`/sitelocation`, data);
  const deleteLocation = async (id: any) => await api.$delete(`/sitelocation/${id}`);
  const getLocation = async (id: any) => await api.$get(`/sitelocation/${id}`);
  const updateLocation = async (id: any, data: any) => await api.$put(`/sitelocation/${id}`, data);
  const sitelocationList = async () => await api.$get(`/sitelocation/list`);
  const updateSiteLocationStatus = async (id: string, data: any) => await api.$put(`/sitelocation/status/${id}`, data);

  return {
    getAllLocation,
    createLocation,
    deleteLocation,
    getLocation,
    updateLocation,
    sitelocationList,
    updateSiteLocationStatus,
  };
}
